import { useEffect, useState } from "react";
import { MapPin, ExternalLink } from "lucide-react";

const ADDRESS = "Centro Comercial La Plaza, Calle Ayala, Chiclana de la Frontera, Cádiz";
const EMBED_URL = `https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`;
const LINK_URL = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`;

export default function MapEmbed() {
  const [consent, setConsent] = useState(() => localStorage.getItem("atento-cookie-consent"));

  useEffect(() => {
    const read = () => setConsent(localStorage.getItem("atento-cookie-consent"));
    window.addEventListener("atento:consent-changed", read);
    return () => window.removeEventListener("atento:consent-changed", read);
  }, []);

  const acceptAndLoad = () => {
    localStorage.setItem("atento-cookie-consent", "accepted");
    window.dispatchEvent(new Event("atento:consent-changed"));
  };

  if (consent === "accepted") {
    return (
      <div
        data-testid="contact-map"
        className="mt-8 overflow-hidden rounded-3xl border border-atento-blue/10 shadow-[0_10px_34px_rgba(27,59,111,0.08)]"
      >
        <iframe
          data-testid="contact-map-iframe"
          title="Mapa con la ubicación del gabinete ATENTO en Chiclana de la Frontera"
          src={EMBED_URL}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
          className="w-full h-64 sm:h-72 border-0 block"
        />
      </div>
    );
  }

  return (
    <div
      data-testid="contact-map"
      className="mt-8 bg-sage-light/60 border border-sage/25 rounded-3xl p-6 sm:p-7 text-center"
    >
      <MapPin className="w-6 h-6 text-sage-dark mx-auto" strokeWidth={1.8} />
      <p className="mt-3 text-sm leading-relaxed text-charcoal/70">
        Por tu privacidad, el mapa de Google solo se carga si aceptas las cookies.
        También puedes abrirlo directamente en Google Maps:
      </p>
      <div className="mt-4 flex flex-col sm:flex-row gap-3 justify-center">
        <button
          onClick={acceptAndLoad}
          data-testid="contact-map-accept"
          className="inline-flex items-center justify-center gap-2 bg-atento-blue hover:bg-atento-dark text-white font-accent font-semibold text-sm px-5 py-2.5 rounded-full transition-colors cursor-pointer"
        >
          Aceptar y ver el mapa
        </button>
        <a
          href={LINK_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-map-external"
          className="inline-flex items-center justify-center gap-2 bg-white border border-sage/30 text-atento-blue hover:bg-sage/10 font-accent font-semibold text-sm px-5 py-2.5 rounded-full transition-colors"
        >
          Cómo llegar
          <ExternalLink className="w-4 h-4" />
        </a>
      </div>
    </div>
  );
}
